import { render, staticRenderFns } from "./NewFooter.vue?vue&type=template&id=574e9655&scoped=true&"
var script = {}
import style0 from "./NewFooter.vue?vue&type=style&index=0&id=574e9655&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574e9655",
  null
  
)

export default component.exports